import { Pipe, PipeTransform } from "@angular/core";
import { DropdownItem } from "@handshake/core-types";

@Pipe({
  name: "dropdownItems",
  standalone: true,
})
export class DropdownItemsPipe implements PipeTransform {
  transform(items: any[], codeField: string = "id", labelField: string = "name", showAll: boolean = false): DropdownItem[] {
    if (!items) {
      return [];
    }

    const getNestedValue = (obj: any, path: string): any => {
      if (!obj || !path) return undefined;
      return path.split(".").reduce((prev, curr) => prev && prev[curr], obj);
    };

    const mapped: DropdownItem[] = items.map((item: any) => ({
      code: getNestedValue(item, codeField),
      label: getNestedValue(item, labelField),
      children: items?.map((childItem) => ({
        code: getNestedValue(childItem, codeField),
        label: getNestedValue(childItem, labelField),
      })),
    }));

    return showAll ? [{ code: "ALL", label: "All" }, ...mapped] : mapped;
  }
}
